/** @format */

const template = `
<sis-typeahead
  class="search-organisation"
  [highlight-search-term]="true"
  [input-formatter]="$ctrl.renderOrganisation"
  [model]="$ctrl.inputItem"
  (model-change)="$ctrl.inputChanged($event)"
  [placeholder]="'SIS_COMPONENTS.ORGANISATION.SEARCH_ORGANISATION.SEARCH_ORGANISATIONS' | translate"
  [required]="$ctrl.required"
  [result-formatter]="$ctrl.renderOrganisation"
  (select-item)="$event.item.disabled ? $event.preventDefault() : $ctrl.selectItem($event.item)"
  [typeahead]="$ctrl.doSearch"></sis-typeahead>
`;
export default template;
